import api from "./core";

const basePath = "api/core/EpisodeOfCare";

export default {
  search(query, extraHeaders = {}) {
    return api.post(`${basePath}/SearchPatientZoho`, query, extraHeaders);
  }
};
